/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbBranchSummary } from './HchbBranchSummary';
import {
    HchbBranchSummaryFromJSON,
    HchbBranchSummaryFromJSONTyped,
    HchbBranchSummaryToJSON,
} from './HchbBranchSummary';

/**
 * 
 * @export
 * @interface HchbBranchList
 */
export interface HchbBranchList {
    /**
     * 
     * @type {Array<HchbBranchSummary>}
     * @memberof HchbBranchList
     */
    data: Array<HchbBranchSummary>;
}

/**
 * Check if a given object implements the HchbBranchList interface.
 */
export function instanceOfHchbBranchList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function HchbBranchListFromJSON(json: any): HchbBranchList {
    return HchbBranchListFromJSONTyped(json, false);
}

export function HchbBranchListFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbBranchList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbBranchSummaryFromJSON)),
    };
}

export function HchbBranchListToJSON(value?: HchbBranchList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(HchbBranchSummaryToJSON)),
    };
}

